/** Keys typed here belong to the field, not to editor or player shortcuts. */
export const isTypingTarget = (el: EventTarget | null) =>
    el instanceof HTMLElement &&
    (el.tagName === "INPUT" ||
        el.tagName === "TEXTAREA" ||
        el.isContentEditable);
